(function () {
  $(document).on("turbolinks:load", function () {
    if (
      !$("body").hasClass(
        "controller-courses-usga_players-league_users_ghin_numbers"
      )
    )
      return;

    $(document).on(
      "change",
      ".batch-ghin-usga-player-select",
      function () {
        const ghin = $(this).find(":selected").data("ghinNumber");
        const userId = $(this).data("userId");
        if (!userId) return;
        if (ghin) $(`#batch-ghin-user-${userId}`).val(ghin);
      }
    );

    $(".batch-ghin-usga-player-select").select2();
  });
})();

